export const GET_ASSET_SURVEY_PROJECT_DROPDOWN_REQUEST = "GET_ASSET_SURVEY_PROJECT_DROPDOWN_REQUEST";
export const GET_ASSET_SURVEY_PROJECT_DROPDOWN_SUCCESS = "GET_ASSET_SURVEY_PROJECT_DROPDOWN_SUCCESS";
export const GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE = "GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE";

export const ADD_ASSET_SURVEY_PROJECT_DATA_REQUEST = "ADD_ASSET_SURVEY_PROJECT_DATA_REQUEST";
export const ADD_ASSET_SURVEY_PROJECT_DATA_SUCCESS = "ADD_ASSET_SURVEY_PROJECT_DATA_SUCCESS";
export const ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE = "ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE";

export const UPDATE_ASSET_SURVEY_PROJECT_DATA_REQUEST = "UPDATE_ASSET_SURVEY_PROJECT_DATA_REQUEST";
export const UPDATE_ASSET_SURVEY_PROJECT_DATA_SUCCESS = "UPDATE_ASSET_SURVEY_PROJECT_DATA_SUCCESS";
export const UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE = "UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE";

export const GET_ASSET_SURVEY_PROJECTS_SUCCESS = "GET_ASSET_SURVEY_PROJECTS_SUCCESS";
export const GET_ASSET_SURVEY_PROJECTS_REQUEST = "GET_ASSET_SURVEY_PROJECTS_REQUEST";
export const GET_ASSET_SURVEY_PROJECTS_FAILURE = "GET_ASSET_SURVEY_PROJECTS_FAILURE";

export const GET_SURVEY_ASSET_SUCCESS = "GET_SURVEY_ASSET_SUCCESS";
export const GET_SURVEY_ASSET_REQUEST = "GET_SURVEY_ASSET_REQUEST";
export const GET_SURVEY_ASSET_FAILURE = "GET_SURVEY_ASSET_FAILURE";

export const UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_SUCCESS = "UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_SUCCESS";
export const UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_FAILURE = "UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_FAILURE";

export const DELETE_ASSET_SURVEY_PROJECT_REQUEST = "DELETE_ASSET_SURVEY_PROJECT_REQUEST";
export const DELETE_ASSET_SURVEY_PROJECT_SUCCESS = "DELETE_ASSET_SURVEY_PROJECT_SUCCESS";
export const DELETE_ASSET_SURVEY_PROJECT_FAILURE = "DELETE_ASSET_SURVEY_PROJECT_FAILURE";

export const GET_ASSET_SURVEY_PROJECT_BY_ID_REQUEST = "GET_ASSET_SURVEY_PROJECT_BY_ID_REQUEST";
export const GET_ASSET_SURVEY_PROJECT_BY_ID_SUCCESS = "GET_ASSET_SURVEY_PROJECT_BY_ID_SUCCESS";
export const GET_ASSET_SURVEY_PROJECT_BY_ID_FAILURE = "GET_ASSET_SURVEY_PROJECT_BY_ID_FAILURE";

export const GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_REQUEST = "GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_REQUEST";
export const GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_SUCCESS = "GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_SUCCESS";
export const GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_FAILURE = "GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_FAILURE";

export const GET_SURVEY_ASSET_BY_ID_REQUEST = "GET_SURVEY_ASSET_BY_ID_REQUEST";
export const GET_SURVEY_ASSET_BY_ID_SUCCESS = "GET_SURVEY_ASSET_BY_ID_SUCCESS";
export const GET_SURVEY_ASSET_BY_ID_FAILURE = "GET_SURVEY_ASSET_BY_ID_FAILURE";

export const GET_SURVEY_ASSET_IMAGES_BY_ID_REQUEST = "GET_SURVEY_ASSET_IMAGES_BY_ID_REQUEST";
export const GET_SURVEY_ASSET_IMAGES_BY_ID_SUCCESS = "GET_SURVEY_ASSET_IMAGES_BY_ID_SUCCESS";
export const GET_SURVEY_ASSET_IMAGES_BY_ID_FAILURE = "GET_SURVEY_ASSET_IMAGES_BY_ID_FAILURE";

export const GET_ASSET_SIGNATURE_REQUEST = "GET_ASSET_SIGNATURE_REQUEST";
export const GET_ASSET_SIGNATURE_SUCCESS = "GET_ASSET_SIGNATURE_SUCCESS";
export const GET_ASSET_SIGNATURE_FAILURE = "GET_ASSET_SIGNATURE_FAILURE";
export const RESET_ASSET_SIGNATURE = "RESET_ASSET_SIGNATURE";

export const UPDATE_SURVEY_ASSET_DATA_REQUEST = "UPDATE_SURVEY_ASSET_DATA_REQUEST";
export const UPDATE_SURVEY_ASSET_DATA_SUCCESS = "UPDATE_SURVEY_ASSET_DATA_SUCCESS";
export const UPDATE_SURVEY_ASSET_DATA_FAILURE = "UPDATE_SURVEY_ASSET_DATA_FAILURE";

export const UPDATE_DEFAULT_IMAGE_REQUEST = "UPDATE_DEFAULT_IMAGE_REQUEST";
export const UPDATE_DEFAULT_IMAGE_SUCCESS = "UPDATE_DEFAULT_IMAGE_SUCCESS";
export const UPDATE_DEFAULT_IMAGE_FAILURE = "UPDATE_DEFAULT_IMAGE_FAILURE";

export const FIND_BEFORE_REPLACE_REQUEST = "FIND_BEFORE_REPLACE_REQUEST";
export const FIND_BEFORE_REPLACE_SUCCESS = "FIND_BEFORE_REPLACE_SUCCESS";
export const FIND_BEFORE_REPLACE_FAILURE = "FIND_BEFORE_REPLACE_FAILURE";

export const RESET_REDUCER = "RESET_REDUCER";

export const RESET_FORM = "RESET_FORM";

export const RESET_ADC_SURVEY_PROJECT_TABLE_DATA_SUCCESS = "RESET_ADC_SURVEY_PROJECT_TABLE_DATA_SUCCESS";
export const RESET_ADC_SURVEY_PROJECT_TABLE_DATA_FAILURE = "RESET_ADC_SURVEY_PROJECT_TABLE_DATA_FAILURE";

export const assetSurveyOrder = [2, 9, 3, 8, 4, 7, 5, 6];
export const eqipmentListOrder = [1, 2, 3];

export const assetSurveyStatus = {
    // 1: { value: "Pending", class: "pending-st", color: "#e61607", disabled: true },
    2: { value: "Synced", class: "inprogress-st", color: "#FF2A00" },
    3: { value: "In Review", class: "submitted-st", color: "#006EFF" },
    8: { value: "Ready for QA/QC", class: "pending-st", color: "#e61607" },
    4: { value: "QA/QC Completed", class: "review-st", color: "#8193A9" },
    7: { value: "Rejected", class: "pending-st", color: "#e61607" },
    5: { value: "Moved to Production", class: "completed-st", color: "#04B934", disabled: true },
    6: { value: "Failed", class: "pending-st", color: "#e61607", disabled: true },
    9: { value: "Initial AI Update", class: "inprogress-st", color: "#FFB300" }
};
export const eqipmentList = {
    1: { value: "Yes" },
    2: { value: "Unclear" },
    3: { value: "No" }
};

export const recommendationSurveyOrder = [2, 9, 3, 6, 5, 4, 10];

export const recommendationSurveyStatus = {
    2: { value: "Synced", class: "inprogress-st", color: "#FF2A00" },
    3: { value: "In Review", class: "submitted-st", color: "#006EFF" },
    4: { value: "Converted", class: "completed-st", color: "#04B934", disabled: true },
    5: { value: "Rejected", class: "inprogress-st", color: "#e61607" },
    6: { value: "TBD", class: "inprogress-st", color: "#e61607" },
    9: { value: "Initial AI Update", class: "inprogress-st", color: "#FFB300" },
    10: { value: "No Action Needed", class: "inprogress-st", color: "#8193A9" }
};

export const AIAnalyseStatus = {
    in_progress: { value: "In Progress", color: "#006EFF", className: "analyse_in_progress" },
    failed: { value: "Failed", color: "#FF0000", className: "analyse_closed" },
    completed: { value: "Completed", color: "#04B934", className: "analyse_completed" },
    closed: { value: "Closed", color: "#FF0000", className: "analyse_closed" }
};
export const surveyTypes = {
    1: "Regular",
    2: "Verification",
    3: "Verification - New Asset"
};

export const surveyStatus = {
    1: { value: "Pending", class: "pending-st", color: "#e61607" },
    2: { value: "In Progress", class: "submitted-st", color: "#006EFF" },
    4: { value: "Completed", class: "completed-st", color: "#04B934" }
};

export const GET_ALL_DATA_LOG_REQUEST = "GET_ALL_DATA_LOG_REQUEST";
export const GET_ALL_DATA_LOG_SUCCESS = "GET_ALL_DATA_LOG_SUCCESS";
export const GET_ALL_DATA_LOG_FAILURE = "GET_ALL_DATA_LOG_FAILURE";

export const RESTORE_DATA_LOG_REQUEST = "RESTORE_DATA_LOG_REQUEST";
export const RESTORE_DATA_LOG_SUCCESS = "RESTORE_DATA_LOG_SUCCESS";
export const RESTORE_DATA_LOG_FAILURE = "RESTORE_DATA_LOG_FAILURE";

export const GET_REVIEWED_ASSETS_COUNT_REQUEST = "GET_REVIEWED_ASSETS_COUNT_REQUEST";
export const GET_REVIEWED_ASSETS_COUNT_SUCCESS = "GET_REVIEWED_ASSETS_COUNT_SUCCESS";
export const GET_REVIEWED_ASSETS_COUNT_FAILURE = "GET_REVIEWED_ASSETS_COUNT_FAILURE";

export const TRANSFER_REVIEWED_ASSETS_REQUEST = "TRANSFER_REVIEWED_ASSETS_REQUEST";
export const TRANSFER_REVIEWED_ASSETS_SUCCESS = "TRANSFER_REVIEWED_ASSETS_SUCCESS";
export const TRANSFER_REVIEWED_ASSETS_FAILURE = "TRANSFER_REVIEWED_ASSETS_FAILURE";

export const GET_COMPLETED_ASSETS_COUNT_REQUEST = "GET_COMPLETED_ASSETS_COUNT_REQUEST";
export const GET_COMPLETED_ASSETS_COUNT_SUCCESS = "GET_COMPLETED_ASSETS_COUNT_SUCCESS";
export const GET_COMPLETED_ASSETS_COUNT_FAILURE = "GET_COMPLETED_ASSETS_COUNT_FAILURE";

export const GET_SURVEY_ASSET_NOTE_BY_ID_REQUEST = "GET_SURVEY_ASSET_NOTE_BY_ID_REQUEST";
export const GET_SURVEY_ASSET_NOTE_BY_ID_SUCCESS = "GET_SURVEY_ASSET_NOTE_BY_ID_SUCCESS";
export const GET_SURVEY_ASSET_NOTE_BY_ID_FAILURE = "GET_SURVEY_ASSET_NOTE_BY_ID_FAILURE";

export const GET_INACCESSIBLE_SPACE_EXPORT_REQUEST = "GET_INACCESSIBLE_SPACE_EXPORT_REQUEST";
export const GET_INACCESSIBLE_SPACE_EXPORT_SUCCESS = "GET_INACCESSIBLE_SPACE_EXPORT_SUCCESS";
export const GET_INACCESSIBLE_SPACE_EXPORT_FAILURE = "GET_INACCESSIBLE_SPACE_EXPORT_FAILURE";

export const GET_INACCESSIBLE_SPACE_REQUEST = "GET_INACCESSIBLE_SPACE_REQUEST";
export const GET_INACCESSIBLE_SPACE_SUCCESS = "GET_INACCESSIBLE_SPACE_SUCCESS";
export const GET_INACCESSIBLE_SPACE_FAILURE = "GET_INACCESSIBLE_SPACE_FAILURE";

export const GET_INACCESSIBLE_SPACE_BY_ID_REQUEST = "GET_INACCESSIBLE_SPACE_BY_ID_REQUEST";
export const GET_INACCESSIBLE_SPACE_BY_ID_SUCCESS = "GET_INACCESSIBLE_SPACE_BY_ID_SUCCESS";
export const GET_INACCESSIBLE_SPACE_BY_ID_FAILURE = "GET_INACCESSIBLE_SPACE_BY_ID_FAILURE";

export const GET_REASONS_BY_ID_REQUEST = "GET_REASONS_BY_ID_REQUEST";
export const GET_REASONS_BY_ID_SUCCESS = "GET_REASONS_BY_ID_SUCCESS";
export const GET_REASONS_BY_ID_FAILURE = "GET_REASONS_BY_ID_FAILURE";

export const ADD_REASON_REQUEST = "ADD_REASON_REQUEST";
export const ADD_REASON_SUCCESS = "ADD_REASON_SUCCESS";
export const ADD_REASON_FAILURE = "ADD_REASON_FAILURE";

export const UPDATE_INACCESSIBLE_SPACE_SETTINGS_REQUEST = "UPDATE_INACCESSIBLE_SPACE_SETTINGS_REQUEST";
export const UPDATE_INACCESSIBLE_SPACE_SETTINGS_SUCCESS = "UPDATE_INACCESSIBLE_SPACE_SETTINGS_SUCCESS";
export const UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE = "UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE";

export const UPDATE_SURVEY_ASSET_FIELDS_REQUEST = "UPDATE_SURVEY_ASSET_FIELDS_REQUEST";
export const UPDATE_SURVEY_ASSET_FIELDS_SUCCESS = "UPDATE_SURVEY_ASSET_FIELDS_SUCCESS";
export const UPDATE_SURVEY_ASSET_FIELDS_FAILURE = "UPDATE_SURVEY_ASSET_FIELDS_FAILURE";

export const UPDATE_ASSET_IMAGE_COMMENT_REQUEST = "UPDATE_ASSET_IMAGE_COMMENT_REQUEST";
export const UPDATE_ASSET_IMAGE_COMMENT_SUCCESS = "UPDATE_ASSET_IMAGE_COMMENT_SUCCESS";
export const UPDATE_ASSET_IMAGE_COMMENT_FAILURE = "UPDATE_ASSET_IMAGE_COMMENT_FAILURE";

export const UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_FAILURE";

export const UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_SUCCESS = "UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_FAILURE = "UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_FAILURE";

export const GET_ASSET_SURVEY_PROJECTS_EXPORT_REQUEST = "GET_ASSET_SURVEY_PROJECTS_EXPORT_REQUEST";
export const GET_ASSET_SURVEY_PROJECTS_EXPORT_SUCCESS = "GET_ASSET_SURVEY_PROJECTS_EXPORT_SUCCESS";
export const GET_ASSET_SURVEY_PROJECTS_EXPORT_FAILURE = "GET_ASSET_SURVEY_PROJECTS_EXPORT_FAILURE";

export const GET_SURVEY_ASSET_EXPORT_REQUEST = "GET_SURVEY_ASSET_EXPORT_REQUEST";
export const GET_SURVEY_ASSET_EXPORT_SUCCESS = "GET_SURVEY_ASSET_EXPORT_SUCCESS";
export const GET_SURVEY_ASSET_EXPORT_FAILURE = "GET_SURVEY_ASSET_EXPORT_FAILURE";

export const GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_REQUEST = "GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_REQUEST";
export const GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_SUCCESS = "GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_SUCCESS";
export const GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE = "GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE";

export const UPDATE_MULTI_SURVEY_ASSET_REQUEST = "UPDATE_MULTI_SURVEY_ASSET_REQUEST";
export const UPDATE_MULTI_SURVEY_ASSET_SUCCESS = "UPDATE_MULTI_SURVEY_ASSET_SUCCESS";
export const UPDATE_MULTI_SURVEY_ASSET_FAILURE = "UPDATE_MULTI_SURVEY_ASSET_FAILURE";

export const RESET_MULTI_COMMON_DATA_SUCCESS = "RESET_MULTI_COMMON_DATA_SUCCESS";
export const RESET_MULTI_COMMON_DATA_FAILURE = "RESET_MULTI_COMMON_DATA_FAILURE";

export const GET_ALL_SURVEY_ASSET_IDS_REQUEST = "GET_ALL_SURVEY_ASSET_IDS_REQUEST";
export const GET_ALL_SURVEY_ASSET_IDS_SUCCESS = "GET_ALL_SURVEY_ASSET_IDS_SUCCESS";
export const GET_ALL_SURVEY_ASSET_IDS_FAILURE = "GET_ALL_SURVEY_ASSET_IDS_FAILURE";

export const GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_REQUEST = "GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_REQUEST";
export const GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_SUCCESS = "GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_SUCCESS";
export const GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_FAILURE = "GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_FAILURE";

export const GET_SURVEYOR_DROPDOWN_REQUEST = "GET_SURVEYOR_DROPDOWN_REQUEST";
export const GET_SURVEYOR_DROPDOWN_SUCCESS = "GET_SURVEYOR_DROPDOWN_SUCCESS";
export const GET_SURVEYOR_DROPDOWN_FAILURE = "GET_SURVEYOR_DROPDOWN_FAILURE";

export const GET_ASSET_VOICE_NOTES_REQUEST = "GET_ASSET_VOICE_NOTES_REQUEST";
export const GET_ASSET_VOICE_NOTES_SUCCESS = "GET_ASSET_VOICE_NOTES_SUCCESS";
export const GET_ASSET_VOICE_NOTES_FAILURE = "GET_ASSET_VOICE_NOTES_FAILURE";

export const DELETE_ASSET_BY_ID_VOICE_NOTES_REQUEST = "DELETE_ASSET_BY_ID_VOICE_NOTES_REQUEST";
export const DELETE_ASSET_BY_ID_VOICE_NOTES_SUCCESS = "DELETE_ASSET_BY_ID_VOICE_NOTES_SUCCESS";
export const DELETE_ASSET_BY_ID_VOICE_NOTES_FAILURE = "DELETE_ASSET_BY_ID_VOICE_NOTES_FAILURE";

export const GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_REQUEST = "GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_REQUEST";
export const GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_SUCCESS = "GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_SUCCESS";
export const GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_FAILURE = "GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_FAILURE";

export const GET_ASSET_SURVEY_FILTER_REQUEST = "GET_ASSET_SURVEY_FILTER_REQUEST";
export const GET_ASSET_SURVEY_FILTER_SUCCESS = "GET_ASSET_SURVEY_FILTER_SUCCESS";
export const GET_ASSET_SURVEY_FILTER_FAILURE = "GET_ASSET_SURVEY_FILTER_FAILURE";
export const SET_APPLIED_FILTER_NAMES = "SET_APPLIED_FILTER_NAMES";

export const SET_CURRENT_AUDIO = "SET_CURRENT_AUDIO";
export const STOP_CURRENT_AUDIO = "STOP_CURRENT_AUDIO";
export const SET_LOADING_STATE = "SET_LOADING_STATE";

export const GET_ASSET_SURVEY_UNIFORMAT_REQUEST = "GET_ASSET_SURVEY_UNIFORMAT_REQUEST";
export const GET_ASSET_SURVEY_UNIFORMAT_SUCCESS = "GET_ASSET_SURVEY_UNIFORMAT_SUCCESS";
export const GET_ASSET_SURVEY_UNIFORMAT_FAILURE = "GET_ASSET_SURVEY_UNIFORMAT_FAILURE";

export const UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_REQUEST = "UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_REQUEST";
export const UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_SUCCESS = "UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_SUCCESS";
export const UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE = "UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE";

export const GET_ASSET_SURVEY_PROJECT_FILTER_REQUEST = "GET_ASSET_SURVEY_PROJECT_FILTER_REQUEST";
export const GET_ASSET_SURVEY_PROJECT_FILTER_SUCCESS = "GET_ASSET_SURVEY_PROJECT_FILTER_SUCCESS";
export const GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE = "GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE";

export const ADD_DYNAMIC_FORM_SUBMIT_REQUEST = "ADD_DYNAMIC_FORM_SUBMIT_REQUEST";
export const ADD_DYNAMIC_FORM_SUBMIT_SUCCESS = "ADD_DYNAMIC_FORM_SUBMIT_SUCCESS";
export const ADD_DYNAMIC_FORM_SUBMIT_FAILURE = "ADD_DYNAMIC_FORM_SUBMIT_FAILURE";

export const GET_DYNAMIC_DROPDOWN_DATA_REQUEST = "GET_DYNAMIC_DROPDOWN_DATA_REQUEST";
export const GET_DYNAMIC_DROPDOWN_DATA_SUCCESS = "GET_DYNAMIC_DROPDOWN_DATA_SUCCESS";
export const GET_DYNAMIC_DROPDOWN_DATA_FAILURE = "GET_DYNAMIC_DROPDOWN_DATA_FAILURE";

export const GET_SUGGESTION_DROPDOWN_BY_CLIENT_REQUEST = "GET_SUGGESTION_DROPDOWN_BY_CLIENT_REQUEST";
export const GET_SUGGESTION_DROPDOWN_BY_CLIENT_SUCCESS = "GET_SUGGESTION_DROPDOWN_BY_CLIENT_SUCCESS";
export const GET_SUGGESTION_DROPDOWN_BY_CLIENT_FAILURE = "GET_SUGGESTION_DROPDOWN_BY_CLIENT_FAILURE";

export const RUN_WELLS_FARGO_SCRIPT_REQUEST = "RUN_WELLS_FARGO_SCRIPT_REQUEST";
export const RUN_WELLS_FARGO_SCRIPT_SUCCESS = "RUN_WELLS_FARGO_SCRIPT_SUCCESS";
export const RUN_WELLS_FARGO_SCRIPT_FAILURE = "RUN_WELLS_FARGO_SCRIPT_FAILURE";

export const SEARCH_AND_REPLACE_REQUEST = "SEARCH_AND_REPLACE_REQUEST";
export const SEARCH_AND_REPLACE_SUCCESS = "SEARCH_AND_REPLACE_SUCCESS";
export const SEARCH_AND_REPLACE_FAILURE = "SEARCH_AND_REPLACE_FAILURE";

export const DELETE_ASSET_IMAGE_REQUEST = "DELETE_ASSET_IMAGE_REQUEST";
export const DELETE_ASSET_IMAGE_SUCCESS = "DELETE_ASSET_IMAGE_SUCCESS";
export const DELETE_ASSET_IMAGE_FAILURE = "DELETE_ASSET_IMAGE_FAILURE";

export const GET_TABLE_SUMMARY_DATA_REQUEST = "GET_TABLE_SUMMARY_DATA_REQUEST";
export const GET_TABLE_SUMMARY_DATA_SUCCESS = "GET_TABLE_SUMMARY_DATA_SUCCESS";
export const GET_TABLE_SUMMARY_DATA_FAILURE = "GET_TABLE_SUMMARY_DATA_FAILURE";

export const REVERT_MOBILE_ASSET_REQUEST = "REVERT_MOBILE_ASSET_REQUEST";
export const REVERT_MOBILE_ASSET_SUCCESS = "REVERT_MOBILE_ASSET_SUCCESS";
export const REVERT_MOBILE_ASSET_FAILURE = "REVERT_MOBILE_ASSET_FAILURE";

export const RESET_DYNAMIC_DROPDOWN_DATA_SUCCESS = "RESET_DYNAMIC_DROPDOWN_DATA_SUCCESS";
export const RESET_DYNAMIC_DROPDOWN_DATA_FAILURE = "RESET_DYNAMIC_DROPDOWN_DATA_FAILURE";

export const RESET_TABLE_DATA_SUCCESS = "RESET_TABLE_DATA_SUCCESS";
export const RESET_TABLE_DATA_FAILURE = "RESET_TABLE_DATA_FAILURE";

export const RESET_IMAGE_REDUCER = "RESET_IMAGE_REDUCER";

export const UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_SUCCESS = "UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_FAILURE = "UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_FAILURE";

export const GET_CLIENT_STANDARD_REQUEST = "GET_CLIENT_STANDARD_REQUEST";
export const GET_CLIENT_STANDARD_SUCCESS = "GET_CLIENT_STANDARD_SUCCESS";
export const GET_CLIENT_STANDARD_FAILURE = "GET_CLIENT_STANDARD_FAILURE";

export const GET_SYNCED_DATA_SUCCESS = "GET_SYNCED_DATA_SUCCESS";
export const GET_SYNCED_DATA_REQUEST = "GET_SYNCED_DATA_REQUEST";
export const GET_SYNCED_DATA_FAILURE = "GET_SYNCED_DATA_FAILURE";

export const UPDATE_SURVEY_CLIENT_DELIVERABLE_SUCCESS = "UPDATE_SURVEY_CLIENT_DELIVERABLE_SUCCESS";
export const UPDATE_SURVEY_CLIENT_DELIVERABLE_REQUEST = "UPDATE_SURVEY_CLIENT_DELIVERABLE_REQUEST";
export const UPDATE_SURVEY_CLIENT_DELIVERABLE_FAILURE = "UPDATE_SURVEY_CLIENT_DELIVERABLE_FAILURE";

export const GET_CLIENT_DELIVERABLE_REQUEST = "GET_CLIENT_DELIVERABLE_REQUEST";
export const GET_CLIENT_DELIVERABLE_SUCCESS = "GET_CLIENT_DELIVERABLE_SUCCESS";
export const GET_CLIENT_DELIVERABLE_FAILURE = "GET_CLIENT_DELIVERABLE_FAILURE";

export const UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_SUCCESS = "UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_FAILURE = "UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_FAILURE";

export const GET_UNIFORMAT_LEVEL_REQUEST = "GET_UNIFORMAT_LEVEL_REQUEST";
export const GET_UNIFORMAT_LEVEL_SUCCESS = "GET_UNIFORMAT_LEVEL_SUCCESS";
export const GET_UNIFORMAT_LEVEL_FAILURE = "GET_UNIFORMAT_LEVEL_FAILURE";

export const GET_DROPDOWN_LIST_REQUEST = "GET_DROPDOWN_LIST_REQUEST";
export const GET_DROPDOWN_LIST_SUCCESS = "GET_DROPDOWN_LIST_SUCCESS";
export const GET_DROPDOWN_LIST_FAILURE = "GET_DROPDOWN_LIST_FAILURE";

export const UPDATE_SURVEY_STANDARD_SUCCESS = "UPDATE_SURVEY_STANDARD_SUCCESS";
export const UPDATE_SURVEY_STANDARD_REQUEST = "UPDATE_SURVEY_STANDARD_REQUEST";
export const UPDATE_SURVEY_STANDARD_FAILURE = "UPDATE_SURVEY_STANDARD_FAILURE";

export const GET_SURVEY_STANDARD_BY_ID_REQUEST = "GET_SURVEY_STANDARD_BY_ID_REQUEST";
export const GET_SURVEY_STANDARD_BY_ID_SUCCESS = "GET_SURVEY_STANDARD_BY_ID_SUCCESS";
export const GET_SURVEY_STANDARD_BY_ID_FAILURE = "GET_SURVEY_STANDARD_BY_ID_FAILURE";

export const GET_CLIENT_DELIVERABLE_FILTER_REQUEST = "GET_CLIENT_DELIVERABLE_REQUEST";
export const GET_CLIENT_DELIVERABLE_FILTER_SUCCESS = "GET_CLIENT_DELIVERABLE_SUCCESS";
export const GET_CLIENT_DELIVERABLE_FILTER_FAILURE = "GET_CLIENT_DELIVERABLE_FAILURE";

export const GET_STANDARD_IMAGES_BY_ID_REQUEST = "GET_STANDARD_IMAGES_BY_ID_REQUEST";
export const GET_STANDARD_IMAGES_BY_ID_SUCCESS = "GET_STANDARD_IMAGES_BY_ID_SUCCESS";
export const GET_STANDARD_IMAGES_BY_ID_FAILURE = "GET_STANDARD_IMAGES_BY_ID_FAILURE";

export const GET_AI_ANALYSE_DATA_REQUEST = "GET_AI_ANALYSE_DATA_REQUEST";
export const GET_AI_ANALYSE_DATA_SUCCESS = "GET_AI_ANALYSE_DATA_SUCCESS";
export const GET_AI_ANALYSE_DATA_FAILURE = "GET_AI_ANALYSE_DATA_FAILURE";

export const POST_AI_ANALYSE_DATA_REQUEST = "POST_AI_ANALYSE_DATA_REQUEST";
export const POST_AI_ANALYSE_DATA_SUCCESS = "POST_AI_ANALYSE_DATA_SUCCESS";
export const POST_AI_ANALYSE_DATA_FAILURE = "POST_AI_ANALYSE_DATA_FAILURE";

export const CLEAR_AI_ANALYSE_DATA_REQUEST = "CLEAR_AI_ANALYSE_DATA_REQUEST";
export const CLEAR_AI_ANALYSE_DATA_SUCCESS = "CLEAR_AI_ANALYSE_DATA_SUCCESS";
export const CLEAR_AI_ANALYSE_DATA_FAILURE = "CLEAR_AI_ANALYSE_DATA_FAILURE";

export const RESET_AI_REDUCER = "RESET_AI_REDUCER";

export const GET_LIST_FOR_SURVEYOR_REQUEST = "GET_LIST_FOR_SURVEYOR_REQUEST";
export const GET_LIST_FOR_SURVEYOR_SUCCESS = "GET_LIST_FOR_SURVEYOR_SUCCESS";
export const GET_LIST_FOR_SURVEYOR_FAILURE = "GET_LIST_FOR_SURVEYOR_FAILURE";

export const GROUP_SURVEY_UPDATE_REQUEST = "GROUP_SURVEY_UPDATE_REQUEST";
export const GROUP_SURVEY_UPDATE_SUCCESS = "GROUP_SURVEY_UPDATE_SUCCESS";
export const GROUP_SURVEY_UPDATE_FAILURE = "GROUP_SURVEY_UPDATE_FAILURE";

export const PATCH_AI_ANALYSE_DATA_REQUEST = "PATCH_AI_ANALYSE_DATA_REQUEST";
export const PATCH_AI_ANALYSE_DATA_SUCCESS = "PATCH_AI_ANALYSE_DATA_SUCCESS";
export const PATCH_AI_ANALYSE_DATA_FAILURE = "PATCH_AI_ANALYSE_DATA_FAILURE";

export const RESET_PATCH_AI_ANALYSIS = "RESET_PATCH_AI_ANALYSIS";

export const ASSET_TABLE_AI_ANALYSIS = "ASSET_TABLE_AI_ANALYSIS";

export const GET_SELECT_ALL_LIST_REQUEST = "GET_SELECT_ALL_LIST_REQUEST";
export const GET_SELECT_ALL_LIST_SUCCESS = "GET_SELECT_ALL_LIST_SUCCESS";
export const GET_SELECT_ALL_LIST_FAILURE = "GET_SELECT_ALL_LIST_FAILURE";

export const GET_STANDARD_TABLE_EXPORT_REQUEST = "GET_STANDARD_TABLE_EXPORT_REQUEST";
export const GET_STANDARD_TABLE_EXPORT_SUCCESS = "GET_STANDARD_TABLE_EXPORT_SUCCESS";
export const GET_STANDARD_TABLE_EXPORT_FAILURE = "GET_STANDARD_TABLE_EXPORT_FAILURE";

export const GET_UNIFORMAT_TABLE_EXPORT_REQUEST = "GET_UNIFORMAT_TABLE_EXPORT_REQUEST";
export const GET_UNIFORMAT_TABLE_EXPORT_SUCCESS = "GET_UNIFORMAT_TABLE_EXPORT_SUCCESS";
export const GET_UNIFORMAT_TABLE_EXPORT_FAILURE = "GET_UNIFORMAT_TABLE_EXPORT_FAILURE";

export const PATCH_AI_ANALYZE_ASSET_DATA_REQUEST = "PATCH_AI_ANALYZE_ASSET_DATA_REQUEST";
export const PATCH_AI_ANALYZE_ASSET_DATA_SUCCESS = "PATCH_AI_ANALYZE_ASSET_DATA_SUCCESS";
export const PATCH_AI_ANALYZE_ASSET_DATA_FAILURE = "PATCH_AI_ANALYZE_ASSET_DATA_FAILURE";

export const GET_ASSET_AI_ANALYSE_KEY_REQUEST = "GET_ASSET_AI_ANALYSE_KEY_REQUEST";
export const GET_ASSET_AI_ANALYSE_KEY_SUCCESS = "GET_ASSET_AI_ANALYSE_KEY_SUCCESS";
export const GET_ASSET_AI_ANALYSE_KEY_FAILURE = "GET_ASSET_AI_ANALYSE_KEY_FAILURE";

export const GET_ENTITY_DROPDOWN_REQUEST = "GET_ENTITY_DROPDOWN_REQUEST";
export const GET_ENTITY_DROPDOWN_SUCCESS = "GET_ENTITY_DROPDOWN_SUCCESS";
export const GET_ENTITY_DROPDOWN_FAILURE = "GET_ENTITY_DROPDOWN_FAILURE";

export const GET_ASSET_GROUP_EDIT_PROGRESS_REQUEST = "GET_ASSET_GROUP_EDIT_PROGRESS_REQUEST";
export const GET_ASSET_GROUP_EDIT_PROGRESS_SUCCESS = "GET_ASSET_GROUP_EDIT_PROGRESS_SUCCESS";
export const GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE = "GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE";

export const RESET_GET_REDUCER = "RESET_GET_REDUCER";

export const REVERT_MOBILE_ASSET_BY_ID_REQUEST = "REVERT_MOBILE_ASSET_BY_ID_REQUEST";
export const REVERT_MOBILE_ASSET_BY_ID_SUCCESS = "REVERT_MOBILE_ASSET_BY_ID_SUCCESS";
export const REVERT_MOBILE_ASSET_BY_ID_FAILURE = "REVERT_MOBILE_ASSET_BY_ID_FAILURE";

export const RESET_DATA_LOG = "RESET_DATA_LOG";

export const dropdownKeys = {
    "assets.site_id": "sites",
    "assets.trade_id": "trades",
    "assets.building_id": "buildings",
    "assets.region_id": "regions",
    "assets.system_id": "systems",
    "assets.sub_system_id": "sub_systems",
    "assets.floor_id": "floors",
    "assets.addition_id": "additions",
    "assets.asset_status_id": "asset_statuses",
    "assets.asset_type_id": "asset_types",
    "assets.client_asset_condition_id": "asset_conditions",
    "assets.main_category_id": "main_categories",
    "assets.manufacturer": "manufacturers",
    "assets.client_standards_id": "client_standards",
    "buildings.main_building_type_id": "building_types",
    manufacturer_id: "manufacturers",
    asset_condition_id: "asset_conditions",
    "assets.manufacturer_id": "manufacturers",
    "assets.sub_category_1_id": "sub_category_1s",
    "assets.sub_category_2_id": "sub_category_2s",
    "assets.sub_category_3_id": "sub_category_3s"
};

export const autoFields = [
    // "buildings.main_building_type_id",
    "assets.client_asset_condition__description",
    // "main_building_type_id",
    "recommendation_type"
];

export const parentFields = {
    building_id: ["site_id", "main_building_type_id"],
    site_id: ["region_id"],
    addition_id: ["building_id"],
    floor: ["building_id"],
    system_id: ["trade_id"],
    sub_system_id: ["system_id"],
    "assets.building_id": ["assets.site_id", "buildings.main_building_type_id"],
    "assets.site_id": ["assets.region_id"],
    "assets.addition_id": ["assets.building_id"],
    "assets.floor_id": ["assets.building_id"],
    "assets.system_id": ["assets.trade_id"],
    "assets.sub_system_id": ["assets.system_id"]
};
